export const CALCULATOR_ONLY = true;

export const MOBILE_TOC_GUTTER = 3;
